import React, { useState } from 'react';
import RegisterForm from './RegisterForm';
import RegisterFormPhone from './RegisterFormPhone';

const RegisterFormContainer: React.FC = () => {
    const [registrationMethod, setRegistrationMethod] = useState<'email' | 'phone'>('email');

    const switchToPhone = () => {
        setRegistrationMethod('phone');
    };

    const switchToEmail = () => {
        setRegistrationMethod('email');
    };

    if (registrationMethod === 'phone') {
        return <RegisterFormPhone onSwitchToEmail={switchToEmail} />;
    }

    return <RegisterForm onSwitchToPhone={switchToPhone} />;
};

export default RegisterFormContainer;
